import Typography from '@components/v2/ui/Typography/Typography';
import { formatProductCodes } from '../../../../../../products/utils/productCodes.utils';
import { ProductCardsBlockVariant } from '../../productCardsBlock.types';
import { useProductCardsHeadingStyles } from './productCardsHeading.styles';

const nameVariantByVariant = {
  card: 'subtitle2',
  row: 'body1',
} as const satisfies Record<ProductCardsBlockVariant, 'subtitle2' | 'body1'>;

const codesVariantByVariant = {
  card: 'micro2',
  row: 'micro1',
} as const satisfies Record<ProductCardsBlockVariant, 'micro1' | 'micro2'>;

interface ProductCardsHeadingProps {
  name: string;
  code: string;
  variant: ProductCardsBlockVariant;
  onOpen: () => void;
  referenceCode?: string | null;
}

const ProductCardsHeading = ({
  name,
  code,
  variant,
  onOpen,
  referenceCode,
}: ProductCardsHeadingProps) => {
  const { classes } = useProductCardsHeadingStyles({ variant });
  const codes = formatProductCodes({ code, referenceCode: referenceCode ?? undefined });

  return (
    <div className={classes.root}>
      <button type="button" className={classes.openButton} onClick={onOpen}>
        <Typography
          variant={nameVariantByVariant[variant]}
          component="span"
          className={classes.name}
          title={name}
        >
          {name}
        </Typography>
      </button>
      <Typography
        variant={codesVariantByVariant[variant]}
        color="textSecondary"
        title={codes}
        noWrap
      >
        {codes}
      </Typography>
    </div>
  );
};

export default ProductCardsHeading;
